<template>
  <div>

    <div class="mb-4" style="max-width: 400px">
      <b-form-group v-if="data_type == 'database'" label="Select Database">
        <b-form-select
          id="input-large"
          size="lg"
          :value="database"
          @change="onDatabaseChange"
          :options="databases"
          required disabled />
      </b-form-group>

      <b-form-group :label="data_type == 'database' ? 'Select Table' : 'Select File'">
        <b-form-select
          id="input-large"
          size="lg"
          :value="collection"
          @change="onCollectionChange"
          :options="collections"
          :disabled="true"
        
          
          required />
      </b-form-group>

      <h4>Join logic</h4>
      <b-form-group description="Select how the different filters are to be joined">
        <b-form-select
          :value="logic"
          @change="onLogicChange"
          :options="['and', 'or'].map(l => ({value: l, text: l.toUpperCase()}))"
          required
          :disabled="working"
          placeholder="Join Logic" />
      </b-form-group>
    </div>

    <h4>Filters</h4>
    <condition
      v-for="cond in filters"
      :collection="collection"
      :database="database"
      v-bind="cond"
      :key="cond.id"
      :show-errors="showErrors"
      @change="d => onFilterChange(cond.id, d)"
      @delete="() => onFilterDelete(cond.id)" />

    <div class="mt-0">
      <b-button
        @click="onAddFilter"
        :disabled="working"
        variant="outline-primary"
        class="px-5"
        size="md">
        Add Filter
      </b-button>
    </div>
  </div>
</template>

<script>
	import _ from 'lodash';
	import uniqid from 'uniqid';
	import Condition from './Condition';

	const createEmptyFilter = () => ({
		column: null,
		operator: null,
		value: null,
		value2: null,
		listValues: [],
		id: uniqid(),
		complete: false
	});

	const nonEmptyFilterList = filters =>
    filters && filters.length ? _.cloneDeep(filters) : [createEmptyFilter()];

	const isComplete = filters =>
    filters && filters.length > 0 && filters.every(({complete}) => complete);


	export default {
		name: 'FilterRules',

    components: {
			Condition
    },

    props: {
			logic: String,
      filters: Array,
      showErrors: Boolean,
      working: Boolean,
      collection: String,
      database: String,
      data_type: String,
      file: String
    },

    // data() {
    //   return {
    //     dataType: 'database',
    //     dataTypeOptions: [
    //         {text: 'Database', value: 'database'},
    //         {text: 'File', value: 'file'}
    //       ]
    //   };
    // },

    computed:{
      collections(){
        //  return this.$store.state.files.collections;
        var collections = [];
        this.$store.state.files.fileList.forEach(file => {
          if (!!file.originalName && file.database === this.database && !collections.includes(file.originalName)) {
            collections.push(file.originalName);
          }
        });
        return collections;
      },

      databases(){
        var databases = [];
        this.$store.state.files.fileList.forEach(file => {
          if (!!file.database && !databases.includes(file.database)) {
            databases.push(file.database);
          }
        });
        return databases;
      }
    },
   

    created() {
			this.onPatch({
				filters: nonEmptyFilterList(this.filters),
        logic: this.logic || "and",
        collection: this.collection || this.collections[0],
        database: this.database || this.databases[0],
        file: this.file
      })
    },

    methods: {
			onPatch(patch) {
				patch["complete"] = isComplete(patch.filters || this.filters);
				this.$emit('patch', patch);
      },

      onCollectionChange(collection){
        this.onPatch({collection});
      },

      onDatabaseChange(database){
        this.onPatch({database});
      },

      onLogicChange(logic) {
				this.onPatch({logic});
      },

			onFilterChange(id, data) {
				const filters = this.filters.map(
					filter => filter.id === id ? {...filter, ...data} : filter);
				this.onPatch({filters});
			},

			onFilterDelete(condID) {
				const filters = this.filters.filter(({id}) => id !== condID);
				this.onPatch({filters: nonEmptyFilterList(filters)});
			},

			onAddFilter() {
				this.onPatch({filters: [...this.filters, createEmptyFilter()]});
			},
    }
   
	};
</script>

<style scoped>

</style>
